import {
  AssetType,
  DeviceCategory,
  OSFamily,
  ResolutionType,
  Source,
  State,
  Status,
} from '@rtkwlf/mr-infra-risk';

import { translateOptions } from '@packages/components/column-store/translate-options/translate-options';

export const riskStateOptions = translateOptions(
  Object.values(State),
  'riskManagement:risks.riskState',
);

export const riskStatusOptions = translateOptions(
  Object.values(Status),
  'riskManagement:risks.riskStatus',
);

export const riskSourceOptions = translateOptions(
  Object.values(Source).filter((s) => s !== Source.Eva),
  'riskManagement:risks.riskSource',
);

export const riskResolutionTypeOptions = translateOptions(
  Object.values(ResolutionType),
  'riskManagement:risks.riskResolutionType',
);

export const riskAssetCategoryOptions = translateOptions(
  Object.values(DeviceCategory),
  'riskManagement:risks.riskAssetCategory',
);

export const riskAssetOSOptions = translateOptions(
  Object.values(OSFamily),
  'riskManagement:risks.riskAssetOSType',
);

export const riskAssetType = translateOptions(
  Object.values(AssetType),
  'riskManagement:risks.assetType',
);
